import AlertBox from 'components/ui/AlertBox';
import moment from 'moment';
import maskUpToLast4Digits from './utils/maskUpToLast4Digits';
import { CP_PAYMENT_STATUS_FAILURE } from '../../../constants/customerPresent';

const createTakeCardPaymentErrorHandler =
  ({ booking, actions }) =>
  async ({ networkError }) => {
    const { reference, customer, currency } = booking;
    const { printReceipt, setAlert } = actions;

    if (!networkError || !networkError.data) {
      setAlert({
        variant: AlertBox.variants.ERROR,
        messageId: 'payments.cardUnknownError'
      });

      return;
    }

    if (!networkError.data.receipt) {
      return;
    }

    setAlert({
      variant: AlertBox.variants.ERROR,
      messageId: 'payments.cardDeclinedError'
    });

    const { date, time, stan, paymentMethod, mid, cardNumber, authMethod, terminalId, aid, panSeq, totalAmount } =
      networkError.data.receipt;

    const dateFormatted = moment(date, 'DD/MM/YYYY').format('DD/MM/YY');
    const amount = totalAmount.match(/[\d,.]+/);

    const printResponse = await printReceipt({
      variables: {
        receiptInput: {
          aId: aid,
          amount,
          authMethod,
          paymentStatus: CP_PAYMENT_STATUS_FAILURE,
          bookingReference: reference,
          cardType: paymentMethod,
          currency,
          customerName: `${customer.firstName} ${customer.lastName}`,
          customerPan: cardNumber,
          issueNumber: panSeq,
          merchantId: maskUpToLast4Digits(mid),
          paymentDate: dateFormatted,
          paymentTime: time,
          receiptNumber: stan,
          terminalId: maskUpToLast4Digits(terminalId)
        }
      }
    });

    if (printResponse && printResponse.data.printReceipt === 'PRINTER_SUCCESS') {
      return;
    }

    setAlert({
      variant: AlertBox.variants.ERROR,
      messageId: 'payments.printReceiptError'
    });
  };

export default createTakeCardPaymentErrorHandler;
